export default __webpack_public_path__ + "static/media/dt-ecoroll.f171910d.svg";